import apiClient from './apiClient'


const getRoles = (tenant) => {
  return apiClient.get(`/${tenant}/Role`)
}


export default {
  getRoles
}
